  <div class="notMobile">
    <p-paginator 
    [rows]="pageSize" 
    [rowsPerPageOptions]="[10,25,50,100]" 
    [totalRecords]="total" 
    [first]="first"
    currentPageReportTemplate="{first} to {last} of {{total | number}} results" 
    [showCurrentPageReport]="true"
    (onPageChange)="paginate($event)" 
    [showFirstLastIcon]="true" 
    arialLabel="Page Count"
    dropdownAriaLabel="Page Count" 
    appNumberFormat>
    </p-paginator><!--{first} to {last} of {totalRecords} results-->
  </div>
  <div class="forMobile">
    <p-paginator 
    [rows]="pageSize" 
    [rowsPerPageOptions]="[10,25,50,100]" 
    [totalRecords]="total" 
    [first]="first"
    currentPageReportTemplate="{first} - {last} of {{total | number}}" 
    [showCurrentPageReport]="true"
    (onPageChange)="paginate($event)" 
    [showFirstLastIcon]="false" 
    arialLabel="Page Count"
    dropdownAriaLabel="Page Count" 
    appNumberFormat>
    </p-paginator><!--{first} to {last} of {totalRecords} results-->
  </div>


